import { type Ref } from 'react';
import cn from 'classnames';
import { Tile, TileHeader } from '@creditflowresearch/uilib/Tile';
import Flex from '@creditflowresearch/uilib/Flex';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import { withTileContext } from '@/creditflowresearch/ui/components/deals/DealTiles/withTileContexts';
import { withDealByProductContext } from '@/creditflowresearch/ui/components/deals/DealTiles/withDealByProductContext';
import { HeaderActions } from '@/creditflowresearch/ui/components/deals/DealListTable/components/HeaderActions';
import TileTabs from '@/creditflowresearch/ui/components/deals/TileTabs';
import DealTileTabSelect from '@/creditflowresearch/ui/components/deals/DealTiles/DealTileTabSelect';
import DealTables from '@/creditflowresearch/ui/components/deals/DealTables';

import styles from '@/creditflowresearch/ui/components/deals/DealTiles/IssueTile/issueTile.module.scss';

export interface IssueTileProps {
  profileType?: ProfileTypes,
  showDealStatusFilters?: boolean,
  titleToolbar?: React.ReactNode,
  title?: React.ReactNode,
  ref?: Ref<HTMLDivElement>,
  showDealDetailsByDefault?: boolean,
  defaultExpandedRowIndexes?: number[],
  containerClassName?: string,
  showTileTabs?: boolean,
}

export const IssueTile = ({
  profileType,
  showDealStatusFilters,
  titleToolbar,
  defaultExpandedRowIndexes,
  showDealDetailsByDefault,
  title = 'Recent New Issue',
  ref,
  containerClassName,
  showTileTabs,
}: IssueTileProps) => (
  <Tile dataTest="dealTile" className={ cn(styles.container, containerClassName) } ref={ ref }>
    <TileHeader
      title={ (
        <>
          <h3>{ title }</h3>
          { titleToolbar }
        </>
      ) }
      dataTest="dealTileHeader"
      noDesktopBottomBorder={ showTileTabs }
    >
      <Flex direction="column" gap={ 10 }>
        <HeaderActions
          showDealStatusFilters={ showDealStatusFilters }
          profileType={ profileType }
        />
        { showTileTabs && (
          <div className={ styles.mobileTabSelect }>
            <DealTileTabSelect />
          </div>
        ) }
      </Flex>
    </TileHeader>
    { showTileTabs && <TileTabs /> }
    <DealTables
      showDealDetailsByDefault={ showDealDetailsByDefault }
      defaultExpandedRowIndexes={ defaultExpandedRowIndexes }
    />
  </Tile>
);

export default withTileContext(withDealByProductContext(IssueTile));
